import * as Yup from 'yup';
import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { LayDcPlanAdoptionContentModel } from '../../models/plan-adoption-form-models';
import { PlanAdoptionRoutes } from '../../routes';
import { LayDcPlanAdoptionWizard } from './lay-dc-plan-adoption-wizard';

export class LayDcQuestionsWizard extends LayDcPlanAdoptionWizard {    

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();

        return {
            ...content,
            gpsType: GpsType.LayDcAdoptionQuestions,
            pageTitle: institutionSettings?.qccoLayRsvpTitle,
            PageDescription: institutionSettings?.qccoLayDCDescription,
            submitLabel: institutionSettings?.qccoQuestionSubmitLabel,
            cancelLabel: institutionSettings?.qccoQuestionCancelLabel,
        };
    }    

    getFormValidationSchema(): any {

        const content = this.getFormContentModel();

        let schema = Yup.object().shape({});

        schema = schema.shape({
            qccoQuestion1: Yup.string().nullable().required(content?.qccoQuestion1Label),
            qccoQuestion2: Yup.string().nullable().required(content?.qccoQuestion2Label),
            qccoQuestion3: Yup.string().nullable().required(content?.qccoQuestion3Label),
        });

        return schema;
    }

    getNextStepUrl() {
        return `${this.wizardOptions?.featureRootPath}${PlanAdoptionRoutes.AdoptionDetails}`;        
    }
}